import React from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { SubTabPanelsProps } from '../types';
import DesktopPanelButton from './DesktopPanelButton';
import {
  DesktopGrid,
  DesktopGridItem,
  Panel,
  PanelButtonContainer,
  PanelRichText,
} from './styles';

const DesktopTabPanels: React.FC<SubTabPanelsProps> = ({
  tabPanels,
  onClick,
  currentTabIndex,
  setCurrentTabIndex,
  ...props
}) => {
  const panelSelectorButtons = tabPanels.map((tabContent, index) => {
    const isSelected = index === currentTabIndex;
    return (
      <DesktopPanelButton
        key={index}
        index={index}
        isSelected={isSelected}
        label={tabContent.label}
        setCurrentTabIndex={setCurrentTabIndex}
      />
    );
  });

  return (
    <DesktopGrid {...componentProps(props)}>
      <PanelButtonContainer desktop={8} tabletLandscape={8} {...componentProps(props)}>
        {panelSelectorButtons}
      </PanelButtonContainer>
      <Panel desktop={8} tabletLandscape={8} data-testid={'Desktop-panel'}>
        <DesktopGridItem>
          <PanelRichText html={tabPanels[currentTabIndex].panelContent} />
        </DesktopGridItem>
      </Panel>
    </DesktopGrid>
  );
};

export default applyComponentTheme(DesktopTabPanels, 'DesktopTabPanels');
